import { ReactQueryProvider } from '#src/fetching/react/react_query_provider.tsx';
import { CreatePage } from '#src/pages/create/create_page.tsx';
import { CreateSuccessPage } from '#src/pages/create/create_success_page.tsx';
import { GroupPage } from '#src/pages/group/group_page.tsx';
import type { ServiceContainer } from '#src/services/services.ts';
import { ServicesProvider } from '#src/services/services.ts';
import { NotFoundPage } from '#src/ui/error/not_found_page.tsx';
import { RouteErrorBoundary } from '#src/ui/error/route_error_boundary.tsx';
import { LoadingPage } from '#src/ui/loading/loading_page.tsx';
import { Toaster } from '@packages/ui/base/toast/toast';
import type { QueryClient } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { createBrowserRouter, RouterProvider } from 'react-router';

const router = createBrowserRouter([
  {
    HydrateFallback: LoadingPage,
    ErrorBoundary: RouteErrorBoundary,
    children: [
      { path: '/new', Component: CreatePage },
      { path: '/new/success', Component: CreateSuccessPage },
      { path: '/s/:groupId', Component: GroupPage },
      { path: '*', Component: NotFoundPage },
    ],
  },
]);

export interface AppProps {
  services: ServiceContainer;
  queryClient: QueryClient;
}

export const App = ({ services, queryClient }: AppProps) => {
  return (
    <ServicesProvider value={services}>
      <ReactQueryProvider client={queryClient}>
        <RouterProvider router={router} />
        <Toaster position="top-center" />
        {/* Automatically excluded from production build */}
        <ReactQueryDevtools initialIsOpen={false} />
      </ReactQueryProvider>
    </ServicesProvider>
  );
};
